<template>
  <div class="page-item">
    <base-section-title class="m-b-24" title="快捷操作" />
    <div class="btn-list">
      <div v-for="(item, index) in list" :key="index" class="btn-item">
        <div class="btn-item-content" @click="operateHandle(item)">
          <div class="m-l-16">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import { workbenchServiceDict } from '@/dictionary/system'
import { mapState } from 'vuex'

export default {
  name: 'HomeFastOperate',

  components: {
    BaseSectionTitle
  },

  data() {
    return {
      workbenchServiceDict,

      purchaser: [
        {
          name: 'BiddingForm',
          permission: 'ROLE_PURCHASER',
          text: '发布招标'
        },
        {
          name: 'InquiryForm',
          permission: 'ROLE_PURCHASER',
          text: '发布询比'
        },
        {
          name: 'CreateCompete',
          permission: 'ROLE_PURCHASER',
          text: '发布竞价'
        },
        {
          name: 'NegotiationForm',
          permission: 'ROLE_PURCHASER',
          text: '发布谈判'
        },
        {
          name: 'RecruitForm',
          permission: 'ROLE_PURCHASER',
          text: '新增招募'
        },
        {
          name: 'ExpertExtractRegister',
          permission: 'ROLE_EXPERT_EXTRACTION',
          text: '专家抽取'
        },
        {
          name: 'DownloadManagement',
          permission: 'ROLE_AGENCY',
          text: '下载管理'
        },
        {
          name: 'PurchaserEntrustForm',
          permission: 'ROLE_PURCHASER',
          text: '发布委托'
        }
      ],
      agency: [
        {
          name: 'AgencyBiddingForm',
          permission: 'ROLE_AGENCY',
          text: '发布招标'
        },
        {
          name: 'AgencyInquiryForm',
          permission: 'ROLE_AGENCY',
          text: '发布询比'
        },
        {
          name: 'AgencyCreateCompete',
          permission: 'ROLE_AGENCY',
          text: '发布竞价'
        },
        {
          name: 'ExpertExtractRegister',
          permission: 'ROLE_EXPERT_EXTRACTION',
          text: '专家抽取'
        },
        {
          name: 'DownloadManagement',
          permission: 'ROLE_AGENCY',
          text: '下载管理'
        }
      ],
      supplier: [
        {
          name: 'PublicTenderList',
          permission: 'ROLE_SUPPLIER',
          text: '公告查询'
        },
        {
          name: 'ParticipateBid',
          permission: 'ROLE_SUPPLIER',
          text: '招标项目查询'
        },
        {
          name: 'ParticipateInquiry',
          permission: 'ROLE_SUPPLIER',
          text: '询比项目查询'
        },
        {
          name: 'ParticipateCompete',
          permission: 'ROLE_SUPPLIER',
          text: '竞价项目查询'
        },
        {
          name: 'ParticipateNegotiation',
          permission: 'ROLE_SUPPLIER',
          text: '谈判项目查询'
        },
        {
          name: 'ParticipateDemand',
          permission: 'ROLE_SUPPLIER',
          text: '需求调查查询'
        },
        {
          name: 'ParticipateRecruit',
          permission: 'ROLE_SUPPLIER',
          text: '招募查询'
        }
      ]
    }
  },

  computed: {
    ...mapState('user', ['roles', 'isAdmin']),
    ...mapState('router', ['currentWorkbench', 'systemRolesList']),
    list() {
      return this.currentWorkbench
        ? this[workbenchServiceDict.translate(this.currentWorkbench)?.alias]
        : []
    },
    roleList() {
      if (this.isAdmin) {
        return this.systemRolesList
      } else {
        return this.roles
      }
    }
  },

  watch: {},

  created() {},

  methods: {
    operateHandle(val) {
      if (this.roleList.includes(val.permission)) {
        this.$router.push({
          name: val.name
        })
      } else {
        this.$message.warning('当前账号无权限')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-item {
  background: $white-color;
  margin: 8px 8px 16px 8px;
  box-sizing: border-box;
  padding: 24px 12px 24px 24px;
  height: 186px;
  .btn-list {
    display: flex;
    flex-wrap: wrap;
    .btn-item {
      width: 25%;
      .btn-item-content {
        display: flex;
        height: 40px;
        border-radius: 2px;
        box-sizing: border-box;
        margin: 0 12px 12px 0;
        align-items: center;
        background: $info-fifth-color;
        font-size: 14px;
        color: $text-color;
        cursor: pointer;
        &:hover {
          background: $primary-fourth-color;
        }
      }
    }
    .no-margin {
      margin: 0;
    }
  }
}
</style>
